import { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import {
  CheckCircleIcon,
  ChevronLeftIcon,
  CloseIcon,
  EventIssueShares,
  ExcerciseIcon,
  PieIcon,
  SarIcon,
} from '../../../../assets/icons/index';
import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import Button from '../../../../components/button/index';
import { ExerciseType } from '../../../../types/pool-plans.types';

export type ExerciseModalProps = {
  onClose: () => void;
  onOpenExerciseStockModal: (type: ExerciseType) => void;
};

type ExerciseModalItemPRops = {
  children: ReactNode;
  className?: string;
  description: ReactNode | string;
  onClick: () => void;
  title: ReactNode | string;
};

export const ExerciseModalItem: FC<ExerciseModalItemPRops> = ({
  description,
  title,
  children,
  onClick,
  className,
}) => (
  <div
    className={twMerge(
      className,
      'flex w-full max-w-[419px] cursor-pointer items-center justify-between py-2',
    )}
    onClick={onClick}
  >
    <div className="flex items-center gap-4">
      <div className="rounded-lg border-[1px] border-[#F2F2F2] bg-white p-[9px]">{children}</div>
      <div className="flex flex-col gap-1">
        <span className="text-sm font-[550] text-[#172335]">{title}</span>
        <div className="flex items-center gap-2 text-label-sm text-gray-500">{description}</div>
      </div>
    </div>
    <Button className="size-4 rounded hover:bg-gray-50" styleType="NONE">
      <ChevronLeftIcon className="size-4 rotate-180" />
    </Button>
  </div>
);

export const TerminatedExerciseModal: FC<ExerciseModalProps> = ({
  onClose,
  onOpenExerciseStockModal,
}) => {
  return (
    <div className="flex w-full max-w-[483px] flex-col gap-4 rounded-xl bg-white px-4 pb-4 shadow-2xl">
      <div className="flex w-full justify-between pb-[10px] pt-[14px]">
        <span className="text-xl font-semibold text-gray-700">
          <AppFormattedMessage id="EXERCISE_RETURN_TO_POOL" />
        </span>
        <Button
          className="flex size-7 items-center justify-center rounded-full"
          onClick={onClose}
          style={{ border: '0.78px solid #F2F2F2', boxShadow: ' 0px 0px 18.67px 0px #00000014' }}
          styleType="NONE"
        >
          <CloseIcon />
        </Button>
      </div>
      <div className="flex w-full flex-col divide-y divide-gray-100 rounded-xl bg-gray-50 p-4">
        <ExerciseModalItem
          description={<AppFormattedMessage id="EXERCISE_STOCK_WITH_EASE" />}
          onClick={() => {
            onClose();
            onOpenExerciseStockModal(ExerciseType.STOCK_OPTIONS);
          }}
          title={<AppFormattedMessage id="EXERCISE_RETURN_STOCK_OPTIONS" />}
        >
          <EventIssueShares />
        </ExerciseModalItem>
        <ExerciseModalItem
          description={<AppFormattedMessage id="EXERCISE_STOCK_WITH_EASE" />}
          onClick={() => {
            onClose();
            onOpenExerciseStockModal(ExerciseType.BSPCE);
          }}
          title={<AppFormattedMessage id="EXERCISE_RETURN_BSPCE" />}
        >
          <EventIssueShares className="-scale-x-100" />
        </ExerciseModalItem>
        <ExerciseModalItem
          description={<AppFormattedMessage id="MANAGE_WARRANTS" />}
          onClick={() => {
            onClose();
            onOpenExerciseStockModal(ExerciseType.WARRANTS);
          }}
          title={<AppFormattedMessage id="EXERCISE_RETURN_EXPIRE_WARRANTS" />}
        >
          <ExcerciseIcon />
        </ExerciseModalItem>
        <ExerciseModalItem
          description={<AppFormattedMessage id="EXECUTE_SAR" />}
          onClick={() => {
            onClose();
            onOpenExerciseStockModal(ExerciseType.SAR);
          }}
          title={<AppFormattedMessage id="EXERCISE_RETURN_SAR" />}
        >
          <SarIcon />
        </ExerciseModalItem>
        <ExerciseModalItem
          description={<AppFormattedMessage id="PAYOUT_PHANTOM_WITH_EASE" />}
          onClick={() => {
            onClose();
            onOpenExerciseStockModal(ExerciseType.PHANTOM);
          }}
          title={<AppFormattedMessage id="PAYOUT_RETURN_PHANTOM" />}
        >
          <PieIcon />
        </ExerciseModalItem>
        <ExerciseModalItem
          description={<AppFormattedMessage id="APPROVE_HURDLE_WITH_EASE" />}
          onClick={() => {
            onClose();
            onOpenExerciseStockModal(ExerciseType.HURDLE);
          }}
          title={<AppFormattedMessage id="APPROVE_RETURN_HURDLE" />}
        >
          <CheckCircleIcon />
        </ExerciseModalItem>
      </div>
    </div>
  );
};
